import { useMutation, useQueryClient } from '@tanstack/react-query';
import { WorkTicketRequestDto } from 'src/api/FiretrolApiClient';
import {
  attachmentApiClient,
  workTicketApiClient,
} from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useCreateWorkTicket(jobId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (request: WorkTicketRequestDto) =>
      workTicketApiClient.create(request),
    meta: {
      successMessage: 'Work ticket created!',
      suppressErrorToast: true,
      errorContext: 'create work ticket',
    },
    onSettled: () => invalidateFor('workTicket.save', qc, { jobId }),
  });
}

export function useUpdateWorkTicket(jobId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      request,
    }: {
      id: string;
      request: WorkTicketRequestDto;
    }) => workTicketApiClient.update(id, request),
    meta: {
      successMessage: 'Work ticket updated!',
      suppressErrorToast: true,
      errorContext: 'update work ticket',
    },
    onSettled: () => invalidateFor('workTicket.save', qc, { jobId }),
  });
}

/** Ticket photos upload to temp storage and are committed with the ticket itself. */
export function useUploadWorkTicketPhoto() {
  return useMutation({
    mutationFn: (file: File) =>
      attachmentApiClient.uploadTempFile('ticket', {
        data: file,
        fileName: file.name,
      }),
    meta: { errorContext: 'work ticket photo upload' },
  });
}
